<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">

        <v-row class="py-1 px-5">
          <v-col cols="12" md="12">
            <v-row>
              <v-col cols="12" class="px-5" PANNELS>
                <v-card NotificationPanel :loading="loading">
                  <v-card-text class="py-0">
                    <v-row>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">people</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">جميع الدفعات</div>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} grey--text`">ادارة الدفعات وطلبات السحب</div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="4" class="text-center py-1" FILTER>
                        <AccountsSearch
                          @searchAccounts="searchAccounts"
                          :search_object="search_object"
                          :loading="loading"
                        />
                      </v-col>
                      <v-col cols="12" md="4" class="text-center py-1" FILTER>
                        <v-autocomplete :items="transaction_statuses" v-model="selectedStatus" label="الحالة"
                          autocomplete="disabled" outlined :filter="filterObject" hide-details clearable dense
                          :loading="loading" prepend-icon="check" @change="filterResource()" item-value="slug"
                          :class="`${arabic ? 'arFont' : 'enFont'}`">
                          <template v-slot:selection="{ attr, on, item, selected }">
                            <span v-bind="attr" :input-value="selected" v-on="on"
                              :class="`${arabic ? 'arFont' : 'enFont'}`">
                              <v-chip x-small>{{ item.en }}</v-chip>
                            </span>
                          </template>
                          <template v-slot:item="{ item }">
                            <span :class="`${arabic ? 'arFont' : 'enFont'}`">
                              {{ item.en }}
                            </span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="4" class="text-center justify-start align-center d-flex">
                        <v-switch hide-details inset :class="`${arabic ? 'arFont' : 'enFont'} mt-0`"
                          label="بانتظار المراجعة" v-model="onlyPending" @change="filterResource()">
                        </v-switch>
                      </v-col>
                      <v-col cols="12" :class="`${arabic ? 'arFont' : 'enFont'}`"
                        style="font-size:18px;font-weight:bold;">
                        المجموع: {{ resource.sum }}$
                      </v-col>
                      <v-col cols="12" md="6" class="text-center py-0" BTN>
                        <v-btn color="success" block :loading="loading" :class="`${arabic ? 'arFont' : 'enFont'}`"
                          @click="exportResource()">
                          تحميل قائمة بالدفات
                          <v-icon right size="15">file_download</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col cols="12" md="6" :class="`${arabic ? 'arFont' : 'enFont'} py-0`">
                        <v-btn block :class="`${arabic ? 'arFont' : 'enFont'}`" :loading="loading" color="primary"
                          @click="dialog = true">
                          <v-icon left>
                            local_atm
                          </v-icon>
                          تسجيل دفعة
                        </v-btn>
                      </v-col>
                      <v-col cols="12" :class="`${arabic ? 'arFont' : 'enFont'}`"
                        style="font-size:18px;font-weight:bold;">
                        <v-layout row justify-center>
                          <v-dialog v-model="dialog" persistent max-width="600">
                            <v-card>
                              <v-card-title :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:20px">تسجيل
                                دفعة</v-card-title>
                              <v-card-text>
                                <v-row class="align-center">
                                  <v-col cols="12" md="12" FILTER>
                                    <v-autocomplete :items="resource.accounts" v-model="newTransaction.account_id"
                                      label="الحساب" autocomplete="disabled" outlined :filter="filterObject"
                                      hide-details clearable dense :loading="loading" prepend-icon="people"
                                      item-value="id" :class="`${arabic ? 'arFont' : 'enFont'}`">
                                      <template v-slot:selection="{ attr, on, item, selected }">
                                        <span v-bind="attr" :input-value="selected" v-on="on"
                                          :class="`${arabic ? 'arFont' : 'enFont'}`">
                                          <v-chip x-small>{{ item.name }} | {{ item.id }}</v-chip>
                                        </span>
                                      </template>
                                      <template v-slot:item="{ item }">
                                        <span :class="`${arabic ? 'arFont' : 'enFont'}`">
                                          {{ item.name }} | {{ item.id }}
                                        </span>
                                      </template>
                                    </v-autocomplete>
                                  </v-col>
                                  <v-col cols="12" FIELD>
                                    <v-autocomplete
                                      v-if="resource.accounts && resource.accounts.length && newTransaction.account_id && resource.accounts.filter(x => x.id == newTransaction.account_id).length"
                                      :items="resource.accounts.filter(x => x.id == newTransaction.account_id)[0].amethods"
                                      v-model="newTransaction.payment_method_id" label="طريقة استلام الارباح"
                                      autocomplete="disabled" outlined :disabled="!newTransaction.account_id"
                                      hide-details clearable dense item-value="id"
                                      :class="`${arabic ? 'arFont' : 'enFont'}`">
                                      <template v-slot:selection="{ attr, on, item, selected }">
                                        <span v-bind="attr" :input-value="selected" v-on="on"
                                          :class="`${arabic ? 'arFont' : 'enFont'}`">
                                          <v-chip x-small>{{ item.name }}</v-chip>
                                        </span>
                                      </template>
                                      <template v-slot:item="{ item }">
                                        <span :class="`${arabic ? 'arFont' : 'enFont'}`">
                                          {{ item.name }} <v-chip x-small color="secondary">
                                            {{ paymentMethods.filter(x => x.slug == item.type)[0].en }}
                                          </v-chip>
                                        </span>
                                      </template>
                                    </v-autocomplete>
                                  </v-col>
                                  <v-col cols="12" md="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
                                    <v-text-field label="قيمة الدفعة" :class="`${arabic ? 'arFont' : 'enFont'}`"
                                      outlined dense @keypress="isNumber($event)" hide-details
                                      v-model="newTransaction.value"></v-text-field>
                                  </v-col>
                                  <v-col cols="12" FIELD>
                                    <v-textarea label="ملاحظات" v-model="newTransaction.note"
                                      :class="`${arabic ? 'arFont' : 'enFont'}`" outlined hide-details
                                      dense></v-textarea>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click.native="dialog = false"
                                  :class="`${arabic ? 'arFont' : 'enFont'}`">الغاء</v-btn>
                                <v-btn color="primary" @click.native="recordTransaction()" :disabled="loading"
                                  :class="`${arabic ? 'arFont' : 'enFont'}`">اضافة</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-layout>
                      </v-col>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
                            <Paging :resourceSettings="resourceSettings" :resource="resource"
                              @loadResource="loadResource" @pageByNumber="pageByNumber" />
                          </v-col>
                          <v-col cols="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
                            <v-expansion-panels focusable>
                              <v-expansion-panel v-for="(r, i) in resource.data" :key="'resource-' + i"
                                style="cursor:pointer;">
                                <v-expansion-panel-header>
                                  <v-row class="pa-0 align-center">
                                    <v-col cols="12" md="3"
                                      :class="`${arabic ? 'arFont' : 'enFont'} pa-0 py-1 font-weight-bold`">
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <span v-bind="attrs" v-on="on">
                                            <div style="font-size:11px;" class="pb-1">القيمة</div>
                                            <div>${{ r.value }}</div>
                                          </span>
                                        </template>
                                        <div class="text-center">
                                          <div :class="`${arabic ? 'arFont' : 'enFont'}`">التاريخ:
                                            {{ getFormat(r.created_at) }}</div>
                                          <div :class="`${arabic ? 'arFont' : 'enFont'}`">اخر تحديث:
                                            {{ getFormat(r.updated_at) }}</div>
                                        </div>
                                      </v-tooltip>
                                    </v-col>
                                    <v-col cols="12" md="3" :class="`${arabic ? 'arFont' : 'enFont'} pa-0 py-1`">
                                      <div style="font-size:11px;" v-if="r.account">ACCOUNT: {{ r.account.name }}</div>
                                      <div style="font-size:11px;" v-if="r.account">ACCOUNT ID:{{ r.account.id }}</div>
                                    </v-col>
                                    <v-col cols="12" md="3"
                                      :class="`${arabic ? 'arFont' : 'enFont'} pa-1 adminSwitch text-right`">
                                      <v-select :items="transaction_statuses" v-model="r.status" :label="i18n.status"
                                        :name="i18n.status" outlined :disabled="user.role != 'master'"
                                        :readonly="user.role != 'master'" hide-details dense @change="updateResource(r)"
                                        item-value="slug" :class="`${arabic ? 'arFont' : 'enFont'}`">
                                        <template v-slot:selection="{ attr, on, item, selected }">
                                          <span v-bind="attr" :input-value="selected" v-on="on"
                                            :class="`${arabic ? 'arFont' : 'enFont'}`">
                                            {{ item.en }}
                                          </span>
                                        </template>
                                        <template v-slot:item="{ item }">
                                          <span :class="`${arabic ? 'arFont' : 'enFont'}`">
                                            {{ item.en }}
                                          </span>
                                        </template>
                                      </v-select>
                                    </v-col>
                                    <v-col cols="12" md="3"
                                      :class="`${arabic ? 'arFont' : 'enFont'} pa-0 py-1 adminSwitch text-right`">
                                      <div class="text-center">
                                        <div :class="`${arabic ? 'arFont' : 'enFont'}`">التاريخ: {{
    getFormat(r.created_at)
}}
                                        </div>
                                        <div :class="`${arabic ? 'arFont' : 'enFont'}`">اخر تحديث:
                                          {{ getFormat(r.updated_at) }}</div>
                                      </div>
                                    </v-col>
                                  </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <v-divider class="pb-3"></v-divider>
                                  <v-row class="pa-0 align-center">
                                    <v-col cols="12" md="6"
                                      :class="`${arabic ? 'arFont' : 'enFont'} pa-1 adminSwitch text-left`">
                                      <v-textarea label="ملاحظات الالغاء" v-model="r.canceled_note"
                                        :class="`${arabic ? 'arFont' : 'enFont'}`" outlined hide-details
                                        dense></v-textarea>
                                    </v-col>
                                    <v-col cols="12" md="12"
                                      :class="`${arabic ? 'arFont' : 'enFont'} pa-1 adminSwitch text-left`">
                                      <v-btn color="success" block text @click="updateResource(r)">
                                        <v-icon left>save</v-icon>
                                        <span>تحديث</span>
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>

                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>

                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AccountsSearch from '@/components/AccountsSearch';
import Paging from '@/components/Paging';
import { format } from 'timeago.js';
import json2csv from 'json2csv';

export default {
  components: { Paging, AccountsSearch },
  data() {
    return {
      loading: false,
      dialog: false,
      vresource: [],
      resource: [],
      search: null,
      rules: {
        required: (value) => !!value || this.i18n.required,
        email: (value) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n.valid_email,
      },
      resourceKeys: [],
      resourceSettings: {
        resourceName: null,
        search: false,
        create: false,
        pagination: true,
      },
      newResource: {},
      editing: false,
      deleting: false,
      selectedAccount: null,
      selectedStatus: null,
      onlyPending: false,
      newTransaction: {},
      page: null,
      search_object:{}

    };
  },
  methods: {
    async searchAccounts(){
      this.filterResource()
    },
    isNumber(ev) {
      const evt = (ev) || window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode !== 46 && charCode !== 45 && charCode !== 46 && !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();
        return false;
      }
      return true;
    },
    recordTransaction() {
      return new Promise(async (res, rej) => {
        this.loading = true;
        await this.$store.dispatch('postResource', { resource: '/transactions', value: this.newTransaction });
        this.loading = false;
        this.dialog = false;
        this.newTransaction = {};
        await this.loadResource();
        res(true);
      });
    },
    getFormat(d) {
      return format(d);
    },
    filterObject(item, queryText, itemText) {
      const v = Object.values(item).filter((x) => typeof x === 'string');
      let a = false;
      v.forEach((x) => {
        if (x.toLowerCase().includes(queryText.toLowerCase())) a = true;
      });
      if (itemText && typeof itemText === 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true;
      return a;
    },
    clipboardSuccessHandler() {
      this.$emit('snackbarNotification', 'Copied', 'success');
    },
    clipboardErrorHandler() {
      this.$emit('snackbarNotification', 'Failed', 'error');
    },

    async pageByNumber(n) {
      return new Promise(async () => {
        this.loading = true;
        this.page = n;
        if (!this.search) {
          this.resource = await this.$store.dispatch('getResource', { resource: this.$route.path, page: `?page=${this.page}${this.buildFilter()}` });
        } else {
          this.resource = await this.$store.dispatch('searchResource', { resource: `${this.$route.path}/search?page=${this.page}`, value: this.search });
        }
        this.loading = false;
      });
    },
    goTo(path) {
      this.$router.push(path).catch(() => { });
    },
    buildFilter() {
      let filter = '';
      if (this.selectedAccount) {
        filter += `&filter[account_id]=${this.selectedAccount.id}`;
      }
      if (this.selectedStatus) {
        filter += `&filter[transaction_status]=${this.selectedStatus}`;
      }
      if (this.onlyPending) {
        filter += '&filter[pending]=true';
      }
      if (this.search_object && this.search_object.search) {
        filter += `&filter[search]=${this.search_object.search}`;
      }
      return filter;
    },
    async filterResource() {
      await this.loadResource();
    },
    async loadResource() {
      return new Promise(async (res, rej) => {
        this.loading = true;

        if (!this.search) {
          this.page = 1;
          this.resource = await this.$store.dispatch('getResource', { resource: `${this.$route.path}?page=${this.page}${this.buildFilter()}` });
        } else {
          this.resource = await this.$store.dispatch('searchResource', { resource: `${this.$route.path}/search?page=${this.page}`, value: this.search });
        }
        this.loading = false;
        res();
      });
    },
    async updateResource(r) {
      const row = { ...r };
      return new Promise(async (res, rej) => {
        this.loading = true;

        if (r.accepted) {
          row.reviewd = true;
        }
        if (row.status === 'canceled') {
          row.canceled = true;
        } else {
          row.canceled = false;
        }
        await this.$store.dispatch('putResource', { resource: `${this.$route.path}/${r.id}`, value: row });
        this.loadResource();
        this.loading = false;
      });
    },
    async exportResource() {
      return new Promise(async (res, rej) => {
        this.loading = true;
        const exp = await this.$store.dispatch('getResource', { resource: `/transactions-export?${this.buildFilter()}` });
        this.exportSimpleData(exp, 'transactions');
        this.loading = false;
        res();
      });
    },
    exportSimpleData(data, name) {
      const a = json2csv.parse(data);
      // console.log(a)
      const csvContent = 'data:text/csv;charset=utf-8,';
      const encodedUri = csvContent + encodeURIComponent(a);
      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      const n = name || 'failed_export';
      link.setAttribute('download', `${n}_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
    showPannel(v) {
      this[v] = true;
      const all = this.subitems.map((x) => x.value);
      all.filter((x) => x != v).forEach((x) => this[x] = false);
    },
    setResourceName() {
      this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')];
    },

    accountChangedHandler(accountInfo) {
      this.selectedAccount = accountInfo;
      this.filterResource();
    },
  },
  computed: {
    api() {
      return this.$store.state.settings.apiBase;
    },
    users() {
      const sa = this.$store.state.user && this.$store.state.user.role === 'superadmin';
      // console.log(sa)
      return this.$store.state.users.filter((x) => {
        if (!sa) {
          return x.superior === this.$store.state.user.level;
        } return x;
      });
    },
    site() {
      return this.$store.state.site;
    },
    items() {
      return this.$store.state.menu;
    },
    superAdmin() {
      return this.$store.state.superAdmin;
    },
    isLogin() {
      return this.$store.state.centralLogin;
    },
    language() {
      return this.$store.state.language;
    },
    globalLoading() {
      return this.$store.state.globalLoading;
    },
    user() {
      return this.$store.state.user;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      return this.$store.state.language === 'ar';
    },
    routeTitle() {
      const main = this.$store.state.menu.filter((x) => x.path === this.$route.path);
      const sub = [].concat(...this.$store.state.menu.map((x) => x.subs)).filter((x) => x).filter((x) => x.path === this.$route.path);
      if (main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text];
      } if (sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text];
      }
      return '';
    },
    roles() {
      return this.$store.state.userRoles;
    },
    notifications() {
      const { notifications } = this.$store.state;
      return notifications.sort((a, b) => b.timestamp - a.timestamp);
    },
    paymentMethods() {
      return this.$store.state.paymentMethods;
    },
    transaction_statuses() {
      return this.$store.state.transaction_statuses;
    },
  },
  async created() {
    this.setResourceName();
    await this.loadResource();
  },
};
</script>

<style>

</style>
